<script>
  import IconCode from '@/assets/img/icon_code.svg'
  import IconImage from '@/assets/img/icon_image.svg'
  import IconLink from '@/assets/img/icon_link.svg'
  import IconVideo from '@/assets/img/icon_video.svg'

  import PlayerAvatar from '@/components/Player/PlayerAvatar'

  export default {
    props: {
      item: {
        type: Object,
        required: true
      }
    },

    components: {
      PlayerAvatar
    },

    data() {
      return {
        imgs: {
          code: IconCode,
          image: IconImage,
          link: IconLink,
          video: IconVideo
        },
        context_data: '',
        lower_type: ''
      }
    },

    created() {
      this.setData()
    },

    watch: {
      item() {
        this.setData()
      }
    },

    computed: {
      notif() {
        return this.item
      },

      name() {
        var name

        if (this.notif.sender.player) {
          name = this.notif.sender.player.name
        }

        return name
      }
    },

    methods: {
      goToNotif() {
        if (!this.notif.read) {
          this.axios.put('/notifications/' + this.notif.id)
            .then(response => {
              Object.assign(this.item, response.data)
            })
        }

        // TODO : redirect to hit card popup / page
        if (this.notif.context_type === 'hits') {
          this.$router.push({name: 'hit', params: {id: this.notif.context.id}})

          if (
            this.$route.name === 'hit' &&
            Number(this.$route.params.id) === this.notif.context.id
          ) {
            window.scroll(0, 0)
          }
        }
      },

      setData() {
        if (this.notif.context_type === 'hits') {
          this.context_data = this.notif.context.title
          this.lower_type = this.notif.context.type.toLowerCase()
        }
      }
    }
  }
</script>

<template>
  <li
    class="media"
    :class="{'is-unread': !notif.read}"
    @click="goToNotif">
    <figure
      class="media-left"
      v-if="notif.sender.player">
      <player-avatar :player="notif.sender.player"/>
    </figure>
    <div class="media-content">
      <div class="content">
        <p v-html="$t('notifications.' + notif.action, {name: name, data: $sanitize(context_data)})"></p>
        <p>
          <time>{{ notif.created_at | moment("from", "now") }}</time>
        </p>
      </div>
    </div>
    <figure
      class="media-right"
      v-if="notif.context_type === 'hits'">
      <p class="image is-24x24">
        <img :src="imgs[lower_type]">
      </p>
    </figure>
  </li>
</template>

<style lang="scss" scoped>
  @import '~bulma/sass/utilities/all';

  .media {
    margin: 0;
    padding: 10px;
    font-size: $size-7;

    &:hover {
      background-color: $grey-lightest;
      cursor: pointer;
    }

    &.is-unread {
      background-color: $grey-lighter;
    }

    .media-right {
      padding: 5px;
      border-radius: 5px;
      background-color: $grey-lightest;
    }

    .content p {
      margin-bottom: 0;
    }
  }
</style>



// WEBPACK FOOTER //
// Item.vue?260971ba